export const CARE_PERIOD_KEYS = {
  all: ['care-period'] as const,
  byUser: (userid: string | number) => [...CARE_PERIOD_KEYS.all, 'by-user', String(userid)] as const,
  activeId: (userid: string | number) => [...CARE_PERIOD_KEYS.all, 'active-id', String(userid)] as const,
} as const;
